import { Component } from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {ModalComponent} from '../../shared/modal/modal.component';
import {Router} from '@angular/router';
import {UserService} from '../../shared/services/user.service';

@Component({
  selector: 'app-support',
  imports: [CommonModule, ReactiveFormsModule, ModalComponent, FormsModule],
  templateUrl: './support.component.html',
  styleUrl: './support.component.scss'
})
export class SupportComponent {
  supportForm: FormGroup;
  isSubmitted = false;

  constructor(private fb: FormBuilder, private router: Router, private userService: UserService) {
    this.supportForm = this.fb.group({
      subject: ['', [Validators.required, Validators.minLength(5)]],
      description: ['', [Validators.required, Validators.minLength(5)]]
    });
  }

  submitRequest() {
    if (this.supportForm.valid) {
      const { subject, description } = this.supportForm.value;
      this.userService.userRequest(subject, description).subscribe({
        next: () => {
          console.log('запрос оправлен')
          this.isSubmitted = true;
          this.supportForm.reset();
        },
        error: (err) => {
          console.error('Ошибка при отправке обращения:', err); //TODO: переделать!!!
        }
      });
    } else {
      console.log('Форма не валидна')
    }
  }

  goHome() {
    this.isSubmitted = false;
    this.router.navigate(['/dashboard']); //TODO: куда это должно вести???
  }
}
